import React from "react";
import { Screen, Text, Loading } from '../components';
import { getItem, setItem } from '../Storage';
import ProviderMessages from '../containers/ProviderMessages';
import ThreadController from '../controllers/threadController';
import { SignIn } from '../containers';
import { StringUtils } from '../utils';
import UserController from '../controllers/userController';

export default class ProviderMessagesScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      thread_chat_consultation_id: '',
      thread_chat_consultation: {},
      loading_screen: true,
      missing_thread: false,
      display_sign_in: false,
      pending_thread_code: '',
      display_no_access: false
    };
  }

  componentDidMount = async () => {
    const location_state = this.props.location && this.props.location.state ? this.props.location.state : {};
    const thread_from_state = location_state.thread_chat_consultation || {};

    if (thread_from_state && thread_from_state._id) {
      setItem('thread_chat_consultation_id', thread_from_state._id);
      const has_access = this.validateThreadAccess(thread_from_state);
      this.setState({
        thread_chat_consultation_id: thread_from_state._id,
        thread_chat_consultation: thread_from_state,
        missing_thread: false,
        display_no_access: !has_access
      });
    }

    const url_codes = this.get_url_codes();
    await this.ensurePartnerFromCode(url_codes.partner_code);
    const code_from_state = thread_from_state && thread_from_state.code ? thread_from_state.code : '';
    const code_to_fetch = url_codes.thread_code || code_from_state;

    const token = getItem('token');

    if (code_to_fetch && token) {
      await this.fetchThreadByCode(code_to_fetch);
      return;
    }

    if (code_to_fetch && !token) {
      this.setState({ loading_screen: false, display_sign_in: true, pending_thread_code: code_to_fetch });
      return;
    }

    if (thread_from_state && thread_from_state._id) {
      this.setState({ loading_screen: false });
      return;
    }

    const stored_thread_id = getItem('thread_chat_consultation_id');
    if (stored_thread_id) {
      this.setState({
        thread_chat_consultation_id: stored_thread_id,
        loading_screen: false,
        missing_thread: false
      });
    } else {
      this.setState({ loading_screen: false, missing_thread: true });
    }
  }

  ensurePartnerFromCode = async (partner_code) => {
    if (!partner_code) { return; }

    let stored_partner = getItem('partner');
    let stored_partner_code = stored_partner && stored_partner.code ? stored_partner.code.toLowerCase() : '';
    let normalized_code = partner_code.toLowerCase();

    if (stored_partner_code === normalized_code) {
      return;
    }

    let partner_details = await UserController.getPartnerDetails({ code: normalized_code });
    if (partner_details) {
      setItem('partner', partner_details);
      setItem('partner_id', partner_details._id);
      setItem('partner_name', partner_details.name);
    }
  }

  get_url_codes = () => {
    let pathname = this.props.location && this.props.location.pathname ? this.props.location.pathname : '';
    if (!pathname && typeof window !== 'undefined') {
      pathname = window.location.pathname || '';
    }

    let segments = pathname.split('/');
    let last_segment = segments && segments.length > 0 ? segments[segments.length - 1] : '';
    last_segment = last_segment.split('?')[0];

    if (!last_segment || last_segment === '' || last_segment === 'prvdmsgs') {
      return { partner_code: '', thread_code: '' };
    }

    let codes = last_segment.split('-');
    let partner_code = codes && codes[0] ? codes[0] : '';
    let thread_code = codes && codes[1] ? codes[1] : '';
    return { partner_code, thread_code };
  }

  fetchThreadByCode = async (thread_code) => {
    if (!thread_code) {
      this.setState({ loading_screen: false, missing_thread: true });
      return;
    }

    const token = getItem('token');
    if (!token) {
      this.setState({ display_sign_in: true, pending_thread_code: thread_code, loading_screen: false });
      return;
    }

    this.setState({ loading_screen: true, missing_thread: false, display_sign_in: false });
    let thread_response = await ThreadController.getThreadConsultationByCode(thread_code);
    let thread_chat_consultation = thread_response && thread_response.success && thread_response.data && (thread_response.data.threadChatConsultation || thread_response.data.thread_chat_consultation)
      ? (thread_response.data.threadChatConsultation || thread_response.data.thread_chat_consultation)
      : {};

    if (thread_chat_consultation && thread_chat_consultation._id) {
      const has_access = this.validateThreadAccess(thread_chat_consultation);
      setItem('thread_chat_consultation_id', thread_chat_consultation._id);
      this.setState({
        thread_chat_consultation_id: thread_chat_consultation._id,
        thread_chat_consultation: thread_chat_consultation,
        loading_screen: false,
        missing_thread: false,
        display_no_access: !has_access
      });
      return;
    } else {
      this.setState({ loading_screen: false, missing_thread: true });
      return;
    }
  }

  validateThreadAccess = (thread) => {
    const user = getItem('user');
    const user_email = user && user.email ? user.email.toLowerCase() : '';
    const thread_email = thread && thread.client_email ? thread.client_email.toLowerCase() : '';

    if (!user_email || !thread_email || user_email !== thread_email) {
      return false;
    }

    return true;
  }

  render_missing_thread = () => {
    return (
      <Screen>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40 }}>
          <Text style={{ fontWeight: 'bold', fontSize: 16 }}>No provider message thread found.</Text>
        </div>
      </Screen>
    );
  }

  render_no_access = () => {
    return (
      <Screen>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40 }}>
          <span className='fas fa-lock' style={{ fontSize: 20, color: '#2563EB', marginBottom: 12 }} />
          <Text style={{ fontWeight: 'bold', fontSize: 16 }}>You do not have access to this chat.</Text>
        </div>
      </Screen>
    );
  }

  render_loading = () => {
    return (
      <Screen>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40 }}>
          <Loading type='chat' title='Opening Provider Messages...' />
        </div>
      </Screen>
    );
  }

  render() {
    if (this.state.loading_screen) {
      return this.render_loading();
    }

    if (this.state.display_sign_in) {
      return (
        <Screen>
          <SignIn success_action={ async () => {
            const pending_code = this.state.pending_thread_code;
            this.setState({ display_sign_in: false, loading_screen: true });
            if (pending_code) {
              await this.fetchThreadByCode(pending_code);
            } else {
              this.setState({ loading_screen: false, missing_thread: true });
            }
          }} />
        </Screen>
      );
    }

    if (!this.state.thread_chat_consultation_id || this.state.missing_thread) {
      return this.render_missing_thread();
    }

    if (this.state.display_no_access) {
      return this.render_no_access();
    }

    return (
      <Screen style={{ overflow: 'hidden' }}>
        <ProviderMessages
          navigate={this.props.navigate}
          thread_chat_consultation_id={this.state.thread_chat_consultation_id}
          thread_chat_consultation={this.state.thread_chat_consultation}
        />
      </Screen>
    );
  }
}
